export default "__VITE_ASSET__hW3vpSwK__"